import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../modules/shared.module';
import { NotSupportedComponent } from '../not-supported/not-supported.component';
import { LoginMobComponent } from './login-mob/login-mob.component';
import { LoginWebComponent } from './login-web/login-web.component';
import { LoginComponent } from './login.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [LoginComponent, LoginWebComponent, LoginMobComponent, NotSupportedComponent],
})
export class LoginModule {}
